<div class="d-flex justify-content-between selection-header">
    <h3 class="m-0 semi-bold">{{'HealthPolicyAgreement'|translate}} </h3>
    <span class="material-icons cursor" (click)="onCloseDialog()">
      clear
      </span>
</div>
<div class="privacy-body-container" (scroll)="onScroll($event)">
    <mat-tab-group [selectedIndex]="indexValue" (selectedIndexChange)="onChangeEvent($event)">
        <mat-tab label="{{'termsandConditions'| translate}}" *ngIf="!consentValueCheck?.termsFlag">
            <div class="container-fluid privacy-container mt-1">
                <div [innerHTML]="termsData">
                </div>
            </div>
        </mat-tab>
        <mat-tab label="{{'privacyNotice'| translate}}" *ngIf="!consentValueCheck?.privacyFlag">
            <div class="container-fluid privacy-container mt-1">
                <div [innerHTML]="privacyData">
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>
<div class="privacy-footer-container">
    <div class="d-flex info-content mt-3">
        <span class="material-icons">info</span>
        <span *ngIf="scrollBoth">{{'ScrollMessageFirst' | translate}} </span>
        <span *ngIf="scrollTnC">{{'ScrollMessageTnC' | translate}} </span>
        <span *ngIf="scrollPrivacy">{{'ScrollMessagePrivacy' | translate}} </span>
    </div>
    <div class="d-flex mt-2 mr-2" *ngIf="!consentValueCheck?.termsFlag">
        <mat-checkbox [disabled]="!enableActionFirst" class="font-weight-bold" (change)="updateCheckedOptions($event)" [(ngModel)]="termsFlag" [ngModelOptions]="{standalone : true}">{{'IAcceptMessage'|translate}}</mat-checkbox>
        <div *ngIf="submitted && tandcView" class="invalid-feedback">
            <div class="ml-3 mt-1">{{'PrivacyPolicyAccept'|translate}}</div>
        </div>
    </div>

    <div class="mt-2 mr-2 d-flex" *ngIf="!consentValueCheck?.privacyFlag">
        <mat-checkbox [disabled]="!enableActionSecond" class="font-weight-bold" (change)="updateCheckedPolicyOptions($event)" [(ngModel)]="privacyFlag" [ngModelOptions]="{standalone : true}">{{'IUnderstoodNotice'|translate}}</mat-checkbox>
        <div *ngIf="submitted && privacyPolicyView" class="invalid-feedback">
            <div class="ml-3 mt-1">{{'PrivacyPolicyAcceptWarning'|translate}}</div>
        </div>
    </div>

    <div class="col-12 col-lg-12  pt-3">
        <div class="text-center">
            <button mat-raised-button color="accent" class="card-header-action mr-3" (click)="onCloseDialog()">{{'Cancel' | translate}}</button>
            <button mat-raised-button color="primary" [disabled]="!enableActionFirst && !enableActionSecond " class="card-header-action" (click)="updateDetails()">{{'Agree' | translate}} </button>

        </div>
    </div>
</div>